<template>
    <div id="app">
        <template v-if="!loading && $route.matched.length">
            <router-view></router-view>
        </template>
        <template v-else-if="loading">
            <div class="d-flex w-100 h-100 align-items-center justify-content-center flex-column">
                <img src="/images/logo.png" class="vh-10 mb-3" />
                <p>{{ $t('base.loading') }}</p>
            </div>
        </template>
        <template v-else>
            <div class="d-flex w-100 h-100 align-items-center justify-content-center flex-column">
                <img src="/images/logo.png" class="vh-10 mb-3" />
                <p>{{ $t('base.loading') }}</p>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            pauseTime: null,

            ioSet: false,
            userSet: false,
            giveawaySet: false
        }
    },
    computed: {
        user() {
            return this.$store.state.auth.user
        },
        config() {
            return this.$store.state.config.data
        }
    },
    mounted() {
        const $this = this
        this.io.connect().then((io) => {
            $this.ioSet = true
            $this.check()
        })

        // stop music if change tab
        document.addEventListener('visibilitychange', () => {
            $this.$store.dispatch('sound/pauseBg', document.hidden)
            let isHome = document.getElementById('page-home')
            if (document.hidden) {
                $this.pauseTime = moment().format()
            } else if (
                isHome &&
                $this.$store.state.auth.loggedIn &&
                $this.pauseTime != null &&
                moment($this.pauseTime).isBefore(moment().subtract(5, 'seconds'))
            ) {
                $this.pauseTime = null
                let loader = document.getElementById('loader')
                if (loader) loader.classList.add('show')
                $this.$store.dispatch('auth/getMe').then((u) => {
                    if (loader) loader.classList.remove('show')
                    $this.$store.dispatch('giveaway/getActive')
                })
            }
        })
    },

    methods: {
        check() {
            if (!this.loading) return

            if (!this.userSet && this.ioSet && !this.giveawaySet && this.$route.matched.length > 0) {
                return (this.loading = false)
            }

            if (this.userSet && this.ioSet && this.$route.matched.length > 0) return (this.loading = false)

            //console.log("userSet", this.userSet,"ioSet", this.ioSet,"giveawaySet", this.giveawaySet, "route", this.$route.matched)
        }
    },

    watch: {
        user() {
            if (!this.loading) return
            const $this = this
            this.userSet = true
            this.check()

            if (this.$store.state.auth.loggedIn && this.$store.state.auth.user.state != 'UNREGISTERED' && !this.giveawaySet) {
                this.$store.dispatch('giveaway/getActive').then((r) => {
                    $this.giveawaySet = true
                    $this.check()
                })
            }
        }
    }
}
</script>
